
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import koreai from "../../assets/koreai.jpg";


function KoreaiMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Koreai magyar fordító</title>
                <meta name='description' content="Ingyenes koreai magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Koreai magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/koreai-magyar-fordito" />
            </Helmet>
            <h1>Koreai magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A koreai nyelvről</h2>
                    <img src={koreai} alt="Koreaia zászló"></img>

                </div>

                <p>A koreai mind Észak-, mind Dél-Korea hivatalos nyelve. A koreai közösségek világszerte beszélik, különösen az Egyesült Államokban, Kanadában és Kínában. A koreai nyelv lenyűgöző, sajátos nyelvi szerkezettel és egyedi írásrendszerrel rendelkezik.</p>

                <p>A koreai a koreai nyelvcsaládba tartozik, és izolált nyelvnek számít, ami azt jelenti, hogy nincs genealógiai kapcsolata más ismert nyelvekkel. Saját nyelvtannal, szókinccsel és kiejtési rendszerrel rendelkezik.</p>

                <p>A Hangul néven ismert koreai írásrendszer egy 14 mássalhangzóból és 10 magánhangzóból álló ábécé. A Hangul nagyra becsülik tudományos felépítése és könnyű tanulhatósága miatt. E karakterek kombinációja szótagblokkokat alkot, amelyeket szavak és mondatok írására használnak.</p>

                <p>Nyelvtanára jellemző az alany-tárgy-ige (SOV) mondatszerkezet. Az igék jellemzően a mondatok végére kerülnek, és a nyelvtani kapcsolatok jelölésére, valamint a témák, alanyok, tárgyak stb. jelölésére partikulákat használnak. A koreai kommunikációban a tisztelettudó kifejezések és az udvariassági szintek használata is döntő fontosságú.</p>

                <p>Hangkészlete a mássalhangzók és magánhangzók széles skálájával rendelkezik. Tartalmaz aspirált mássalhangzókat, kettős mássalhangzókat és magánhangzó-kombinációkat. A helyes kiejtés elengedhetetlen a pontos kommunikációhoz és a koreai nyelv megértéséhez.</p>

                <p>A koreai szókincs a régi koreai szavakból ered, de más nyelvekből, különösen az angolból és a kínaiból származó kölcsönszavakat is tartalmaz. A koreai társadalomban gyakori a tiszteletadás és a hivatalos beszéd, ami a tisztelet és a társadalmi hierarchia kulturális hangsúlyozását tükrözi.</p>

                <p>A kultúra és történelem szorosan kapcsolódik a nyelvhez. A koreai nyelv tanulása betekintést nyújt Korea gazdag örökségébe, beleértve a hagyományokat, az irodalmat, a zenét és a filmművészetet. A koreai társadalom, szokások és értékek megértését is elősegíti.</p>

                <p>A koreai nyelvtudás számos lehetőség előtt nyit ajtót. Dél-Korea a világgazdaság egyik főszereplője, jelentős előrelépésekkel a technológia, a szórakoztatás és az üzleti élet területén. A koreai nyelv ismerete előnyös lehet olyan területeken, mint a nemzetközi üzleti élet, a fordítás, a turizmus és a tudományos élet.</p>




            </section>
        </>

    )
}

export default KoreaiMagyar;